import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-geist\",\"display\":\"swap\"}],\"variableName\":\"geist\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-geist-mono\",\"display\":\"swap\"}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ContourCanvas"] */ "/app/packages/ui/src/ContourCanvas.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/NavDrawer.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/NavMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/ThemeSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useReducedMotion"] */ "/app/packages/ui/src/useReducedMotion.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useTheme"] */ "/app/packages/ui/src/useTheme.ts");
